import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./view/styles/reset.scss";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./reducer";
import "./locales";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}
